import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE } from "./constants";

const iniState = {
  loading: false,
  contactsList: [],
  records: [],
  page: 0,
  pageSize: 10,
  pages: 1,
  total: 0
};

const model = createHandlers({
  iniState,
  reducers: {
    executeAction: R.identity,
    onDoneAddContact: R.identity,
    initFetchContactData: R.identity,
    fetchContactDataWithPage: R.identity,
    setContactDataData: (
      _,
      { payload: { contacts = [], pagination = {} } }
    ) => ({
      contactsList: contacts,
      page: pagination.page,
      pages: pagination.pages,
      total: pagination.total,
      pageSize: pagination.pageSize
    }),
    selectRecord: (state, { payload }) => {
      const isPresent = R.contains(payload, state.records);

      const updatedRecords = R.ifElse(
        R.always(isPresent),
        R.reject(R.equals(payload)),
        R.append(payload)
      )(state.records);
      return { records: updatedRecords };
    }
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
